const state = {
  // polygon triggers: see watchers in PolygonShape.vue
  activePolygonId: "",
  editPolygonId: "",
  deletePolygonId: "",
  isDrawing: false,
  // clearSelectionTrigger: 0,

  markerIndex: 0,

  // track what is currently active
  activeElement: null,
  activeElementType: "", // tag | marker | polygon?

  // slides are special, can be active when activeElement is also active
  activeSlide: null,

  // track multi select items
  selectedElements: [],

  isMenuOpen: false,
};

const getters = {
  getActiveElement(state) {
    return {
      element: state.activeElement,
      type: state.activeElementType,
    };
  },

  getActiveMarker(state) {
    if (state.activeElementType !== "marker") return null;

    return state.activeElement.markers[state.markerIndex];
  },

  getActiveSlide(state) {
    return state.activeSlide;
  },

  getSelectedElements(state) {
    return state.selectedElements;
  },

  getIsMenuOpen(state) {
    return state.isMenuOpen;
  },
};

const actions = {};

const mutations = {
  startPolygon(state, id) {
    state.activePolygonId = id;
    state.isDrawing = true;
  },

  editPolygon(state, id) {
    state.editPolygonId = id;
    state.isDrawing = false;
  },

  deletePolygon(state, id) {
    state.activeElement.polygons = [];
    state.isDrawing = false;
  },

  clearPolygon() {
    state.points = [];
    state.isDrawing = false;
  },

  // clearSelection(state) {
  //   state.clearSelectionTrigger = state.clearSelectionTrigger + 1;
  // },

  deselectPolygon(state) {
    state.isDrawing = false;
    state.activePolygonId = "";
    state.editPolygonId = "";
    state.deletePolygonId = "";
  },

  deselectActiveElement() {
    state.activeElement = null;
    state.activeElementType = "";
    state.selectedElements = [];
    state.isMenuOpen = false;
  },

  deselectAll(state) {
    state.isDrawing = false;
    state.isMenuOpen = false;
    state.activePolygonId = "";
    state.editPolygonId = "";
    state.deletePolygonId = "";
    state.activeElement = null;
    state.activeElementType = "";
    state.activeSlide = null;
    state.selectedElements = [];
    state.markerIndex = null;
  },

  setActiveSlide(state, slide) {
    state.activeElement = null;
    state.activeElementType = "";
    state.selectedElements = [];

    if (slide) {
      slide.type = "slide";
      state.activeElement = slide;
      state.activeElementType = "slide";
      state.activeSlide = slide;
    } else {
      state.activeElement = null;
      state.activeElementType = "";
      state.activeSlide = null;
    }
  },

  setIsMenuOpen(state, isOpen) {
    state.isMenuOpen = isOpen;
  },

  addToSelectedElements(
    state,
    { element, elementType, markerIndex, isSingle }
  ) {
    // normalise element position
    if (element.marker) {
      element.pos = element.marker;
    }

    if (isSingle) {
      state.activeElement = element;
      state.activeElementType = elementType;
      state.selectedElements = [element];
      state.markerIndex = markerIndex;
      return;
    }

    // if nothing is selected yet
    // set activeElement, activeElementType, selectedElements
    if (!state.selectedElements.length && !state.activeElement) {
      state.activeElement = element;
      state.activeElementType = elementType;
      state.selectedElements = [element];
    } else {
      const exists = state.selectedElements.some(
        (existing) => existing._id === element._id
      );

      if (exists) {
        state.selectedElements = state.selectedElements.filter(
          (existing) => existing._id !== element._id
        );
      } else {
        state.selectedElements.push(element);
      }
    }
  },

  setSelectedElements(state, elements) {
    state.selectedElements = elements;
  },

  // TODO: check if activeElement is already selected
  // if it is add is not the same as newElement, add to selectedElements
  // - so far only got the selectedElements to track which elements are selected,
  // could not implement vuex store use only in DraggableElements.vue (reverted back to local state)
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
